import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';

/* @ngInject */
export function CourseSetupWizardViewController (appData, featureFlag: NgxFeatureFlagService) {
	const vm = this;

	vm.$onInit = () => {
		vm.course = appData.userGroup;
		vm.options = {
			isLti: true,
			hideName: true
		};
		vm.featureFlag = featureFlag;
		vm.hasLicense = true;
		vm.licenseTrigger$ = null;
	};
}
